import React from "react";
import { NavDropdown, MenuItem } from "react-bootstrap";
import { logout } from "../actions/auth";
import { username } from "../selectors/auth";
import { push } from "react-router-redux";
import { connect } from "react-redux";

export default connect(
  (state, ownProps) => ({
    username: username(state),
  }),
  (dispatch, ownProps) => ({
    logout: () => {
      dispatch(logout());
      dispatch(push("/"));
    },
  }),
)(({ username, logout }) => (
  <NavDropdown
    eventKey="3.0"
    title={
      <span>
        <i className="glyphicon glyphicon-user" /> {username}
      </span>
    }
    id="account-nav"
  >
    <MenuItem id="log-out" eventKey="3.1" onClick={logout}>
      Log Off
    </MenuItem>
  </NavDropdown>
));



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/AccountNav.js